var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mb-4"},[_c('v-col',{staticClass:"pt-1",attrs:{"cols":"12","sm":"4"}},[_c('FileUpload',{attrs:{"multi":true,"files":_vm.statePassportFiles,"label":"Паспорт","groupName":"passport","name":"passport"},on:{"attachment-file-add":_vm.addPassport,"attachment-file-remove":_vm.removePassport}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }